<div class="paint-presets">
    <div class="paint-presets__group" *ngFor="let group of groupedPresets">
      <div class="text-10 text-uppercase text-dim pv-2 pl-1">
        {{ group.label }}
      </div>
      
      <div class="paint-presets__item"
        [ngClass]="{'paint-presets__item--selected': isSelected(preset.recipe)}"
        *ngFor="let preset of group.items"
        (click)="handleRecipeClick(preset.recipe)">
    
        <div [ngSwitch]="preset.icon">
          <div class="paint-presets__preview" *ngSwitchCase="'_color'">
            <app-paint-palette-swatch [colorRecipe]="preset.recipe">
            </app-paint-palette-swatch>
          </div>
          
          <div class="paint-presets__preview" *ngSwitchDefault>
            <fa-icon [icon]="preset.icon" size="md"></fa-icon>
          </div>
        </div>
    
        <div class="paint-presets__label">
          <span class="text-12">{{preset.label}}</span>
        </div>
      </div>
  
    </div>
  
  </div>
